export const ELocalStorageKey = {
  I18nextLng: "i18nextLng",
  MauthAuthorizationCode: "mauthAuthorizationCode",
  LastVisitedCommunity: "lastVisitedCommunity",
} as const;

export type ELocalStorageKey =
  typeof ELocalStorageKey[keyof typeof ELocalStorageKey];
